import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import Aside from "@/view/layout/aside";
import HistoryComponent from "@/view/layout/aside/historyComponent/history";
import Screenfull from "@/view/layout/screenfull";
import Search from "@/view/layout/search/search";
import BottomInfo from "@/view/layout/bottomInfo/bottomInfo";
import { mapGetters, mapActions } from "vuex";
import CustomPic from "@/components/customPic";
export default {
  name: "Layout",
  data: function data() {
    return {
      titleName: process.env.VUE_APP_PROJECT_NAME,
      show: false,
      isCollapse: false,
      isSider: true,
      isMobile: false,
      isShadowBg: false,
      loadingFlag: false,
      reloadFlag: true,
      value: ""
    };
  },
  components: {
    Aside: Aside,
    HistoryComponent: HistoryComponent,
    Screenfull: Screenfull,
    Search: Search,
    BottomInfo: BottomInfo,
    CustomPic: CustomPic
  },
  methods: _objectSpread(_objectSpread({}, mapActions("user", ["LoginOut"])), {}, {
    reload: function reload() {
      var _this = this;
      this.reloadFlag = false;
      this.$nextTick(function () {
        _this.reloadFlag = true;
      });
    },
    totalCollapse: function totalCollapse() {
      this.isCollapse = !this.isCollapse;
      this.isSider = !this.isCollapse;
      this.isShadowBg = !this.isCollapse;
      this.$bus.emit("collapse", this.isCollapse);
    },
    toPerson: function toPerson() {
      this.$router.push({
        name: "person"
      });
    },
    changeShadow: function changeShadow() {
      this.isShadowBg = !this.isShadowBg;
      this.isSider = !!this.isCollapse;
      this.totalCollapse();
    }
  }),
  computed: _objectSpread(_objectSpread({}, mapGetters("user", ["userInfo"])), {}, {
    title: function title() {
      return this.$route.meta.title || "当前页面";
    },
    matched: function matched() {
      return this.$route.matched;
    },
    key: function key() {
      return this.$route.fullPath;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;
    var screenWidth = document.body.clientWidth;
    if (screenWidth < 1000) {
      this.isMobile = true;
      this.isSider = false;
      this.isCollapse = true;
    } else if (screenWidth >= 1000 && screenWidth < 1200) {
      this.isMobile = false;
      this.isSider = false;
      this.isCollapse = true;
    } else {
      this.isMobile = false;
      this.isSider = true;
      this.isCollapse = false;
    }
    this.$bus.emit("collapse", this.isCollapse);
    this.$bus.emit("mobile", this.isMobile);
    this.$bus.on("reload", this.reload);
    this.$bus.on("showLoading", function () {
      _this2.loadingFlag = true;
    });
    this.$bus.on("closeLoading", function () {
      _this2.loadingFlag = false;
    });
    window.onresize = function () {
      return function () {
        var screenWidth = document.body.clientWidth;
        if (screenWidth < 1000) {
          _this2.isMobile = true;
          _this2.isSider = false;
          _this2.isCollapse = true;
        } else if (screenWidth >= 1000 && screenWidth < 1200) {
          _this2.isMobile = false;
          _this2.isSider = false;
          _this2.isCollapse = true;
        } else {
          _this2.isMobile = false;
          _this2.isSider = true;
          _this2.isCollapse = false;
        }
        _this2.$bus.emit("collapse", _this2.isCollapse);
        _this2.$bus.emit("mobile", _this2.isMobile);
      }();
    };
  }
};